






import { Component, Vue } from 'vue-property-decorator';
import MaintenanceView from '@/components/MaintenanceView.vue';
import { isMaintenance, maintenanceStart, maintenanceEnd } from '@/resources/application';

@Component({
  components: {
    MaintenanceView
  }
})
export default class Parts extends Vue {
  private isLoading: boolean = false;
  private timeoutId: number = -1;

  private get isMaintenance(): boolean {
    return this.$store.state.maintenance.isMaintenance;
  }

  public created(): void {
    // MEMO: 通信でメンテナンスか確認することを想定した非同期実装
    // MEMO: 503エラーの実装により、本番でこのブロックを使われることはなくなりそう。メンテナンスページの実装確認用にコードを残す
    if (isMaintenance) {
      this.isLoading = true;
      this.timeoutId = window.setTimeout((): void => {
        this.isLoading = false;
        this.$store.commit('maintenance/setMaintenance', isMaintenance);
        this.$store.commit('maintenance/setStart', { date: maintenanceStart });
        this.$store.commit('maintenance/setEnd', { date: maintenanceEnd });
        this.$store.commit('maintenance/setTitle', { title: null });
        this.$store.commit('maintenance/setMessage', { message: null });
      }, 1000);
    }
  }

  public beforeDestroy(): void {
    window.clearTimeout(this.timeoutId);
  }
}
